import wixApplication from 'wix-application';

let visibleChangedOnce = false;

$w.onReady(function () {
  if (!$widget.props.startAnimationWhenVisible) {
    setup($widget.props);
  }
});

let timeout = -1;
$widget.onPropsChanged((oldProps, newProps) => {
  clearTimeout(timeout);

  timeout = setTimeout(() => {
    setup(newProps);
  }, 1000);
});

$w('#customElement1').onViewportEnter(() => {
  if (!visibleChangedOnce && $widget.props.startAnimationWhenVisible) {
    visibleChangedOnce = true;
    setup($widget.props);
  }
});

async function setup(props) {
  const instance = await wixApplication.getDecodedAppInstance();
  // const plan = 'premium';
  const plan = instance.vendorProductId ?? 'basic';

  let repeat = props.repeat;
  if (repeat === 0) {
    repeat = 1;
  } else if (repeat < 0) {
    repeat = 99999999;
  }

  const typewriter = $w('#customElement1');

  typewriter.seoMarkup = props.text;

  const sentences = [];

  if (plan !== 'premium') {
    sentences.push(props.sentences[0]);
  } else {
    props.sentences.forEach((sentence, i) => {
      if (i !== 0) {
        sentences.push(sentence);
      }
    });

    sentences.push(props.sentences[0]);
  }
  
  console.log(props);

  // Send as JSON since wix sends arrays and objects as strings
  // for some reason, by sending it as JSON ourselves we
  // control the process.
  const config = JSON.stringify({
    repeat: plan === 'premium' ? repeat : 1,
    repeatDelay: props.repeatDelay,
    sentences: sentences,
    sentenceDelay: props.sentenceDelay,
    delay: props.delay,
    autoPlayAfter: props.autoPlayAfter,
    text: plan === 'premium' ? props.sentences[0] : '',
    pauseOnHover: props.pauseOnHover,
    autoPlay: true,
    font: props.font,
    fontSize: emptyDefault(props.fontSize, '42px'),
    fontColor: emptyDefault(props.fontColor, 'black'),
    cursorColor: emptyDefault(props.cursorColor, 'black'),
    cursorWidth: emptyDefault(props.cursorWidth, '2px'),
    textAlign: props.textAlign,
    useCustomCSS: plan === 'premium' ? props.useCustomCSS : false,
  });

  typewriter.setAttribute('config', config);
}

function emptyDefault(value, defaultValue) {
  if (value.trim() === '') {
    return defaultValue;
  } else {
    return value;
  }
}